'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var listbox = require('@react-aria/listbox');
var list$1 = require('@react-stately/list');
var utils = require('@react-aria/utils');
var list = require('@andes/list');
var itemNodeGenerator = require('@andes/list/build/generators/itemNodeGenerator');
var includes = require('@andes/common/build/utils/includes');
var isMobile = require('@andes/common/build/utils/isMobile');
var _jsx = require('@babel/runtime/helpers/jsx');
var classNames = require('classnames');
var getListItemClassNames = require('@andes/list/build/utils/getListItemClassNames');
var keyboardCodes = require('@andes/common/build/constants/keyboardCodes');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var itemNodeGenerator__default = /*#__PURE__*/_interopDefaultLegacy(itemNodeGenerator);
var includes__default = /*#__PURE__*/_interopDefaultLegacy(includes);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var getListItemClassNames__default = /*#__PURE__*/_interopDefaultLegacy(getListItemClassNames);
const ListOption = () => null;
ListOption.displayName = 'ListOption';
ListOption.getCollectionNode = itemNodeGenerator__default["default"];
var ListOption$1 = ListOption;
const SUPPORTED_ITEM_TYPES = ['ListItem', 'DropdownItem'];
const SUPPORTED_GROUP_TYPES = ['ListGroup', 'DropdownGroup'];
const isSupportedType = function (child) {
  var _child$type, _child$type2, _child$type3, _child$type4;
  let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!child) return false;
  return includes__default["default"](types, ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) || ((_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.name)) || includes__default["default"](types, ((_child$type3 = child.type) === null || _child$type3 === void 0 || (_child$type3 = _child$type3.wraps) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) || ((_child$type4 = child.type) === null || _child$type4 === void 0 ? void 0 : _child$type4.name));
};
var isSupportedType$1 = isSupportedType;
const isSupportedGroupType = child => isSupportedType$1(child, SUPPORTED_GROUP_TYPES);
var isSupportedGroupType$1 = isSupportedGroupType;
const isSupportedItemType = child => isSupportedType$1(child, SUPPORTED_ITEM_TYPES);
var isSupportedItemType$1 = isSupportedItemType;
const useChildrenAdapter = children => React.Children.map(children, child => {
  if (isSupportedItemType$1(child)) return /*#__PURE__*/React__default["default"].createElement(ListOption$1, child.props);
  if (isSupportedGroupType$1(child)) {
    const groupChildren = React.Children.map(child.props.children, item => {
      if (isSupportedItemType$1(item)) return /*#__PURE__*/React__default["default"].createElement(ListOption$1, item.props);
      return item;
    });
    return /*#__PURE__*/React__default["default"].createElement(list.ListGroup, child.props, groupChildren);
  }
  return child;
});
var useChildrenAdapter$1 = useChildrenAdapter;
const _excluded$2 = ["item", "state"],
  _excluded2 = ["onClick", "onKeyDown"],
  _excluded3 = ["onSelect"];
const ListBoxItem = _ref => {
  let {
      item,
      state
    } = _ref,
    otherProps = _objectWithoutProperties__default["default"](_ref, _excluded$2);
  const {
    key,
    props: listItemProps
  } = item;
  const itemSelectionRef = React.useRef(null);
  const {
    optionProps,
    isSelected: selected
  } = listbox.useOption({
    key
  }, state, itemSelectionRef);
  const inheritedProps = _objectSpread__default["default"](_objectSpread__default["default"]({}, listItemProps), {}, {
    key,
    selected
  });
  const listItemClassNames = getListItemClassNames__default["default"](utils.mergeProps(inheritedProps, optionProps, otherProps));
  const itemClassName = classNames__default["default"](listItemClassNames, {
    'andes-list__item-with-selection-component': !!otherProps.selectionComponent
  });
  const {
      onClick,
      onKeyDown
    } = optionProps,
    otherOptionProps = _objectWithoutProperties__default["default"](optionProps, _excluded2);
  const {
      onSelect
    } = otherProps,
    otherOtherProps = _objectWithoutProperties__default["default"](otherProps, _excluded3);
  const onClickHandler = e => {
    const {
      disabled,
      value,
      onSelect: inheritedOnSelect
    } = inheritedProps;
    const {
      onClick: inheritedOnClick
    } = otherProps;
    if (!disabled) {
      if (typeof inheritedOnClick === 'function') inheritedOnClick(e, value);
      if (typeof onClick === 'function') onClick(e);
      if (typeof inheritedOnSelect === 'function') inheritedOnSelect(e, {
        value
      });
      if (typeof onSelect === 'function') onSelect(e, {
        value
      });
    }
  };
  const handleOnKeyDown = event => {
    if (typeof onKeyDown === 'function') onKeyDown(event);
    if (event.code === keyboardCodes.ENTER || event.code === keyboardCodes.SPACE) {
      onClickHandler(event);
    }
  };
  const getCheckbox = () => {
    const {
      selectionComponent: Check
    } = otherProps;
    return /*#__PURE__*/React.isValidElement(Check) ? /*#__PURE__*/_jsx__default["default"]("div", {
      className: "andes-list__item-selection-control"
    }, void 0, /*#__PURE__*/React.cloneElement(Check, {
      checked: inheritedProps.selected,
      disabled: inheritedProps.disabled
    })) : null;
  };
  const itemProps = _objectSpread__default["default"]({}, utils.mergeProps(inheritedProps, otherOtherProps));
  const {
    title,
    description,
    rightContent,
    primary: _willdeprecate$primary,
    secondary: _willdeprecate$secondary,
    tertiary: _willdeprecate$tertiary
  } = itemProps;
  const computedTitle = title || _willdeprecate$primary;
  const computedDescription = description || _willdeprecate$secondary;
  const computedRightContent = rightContent || _willdeprecate$tertiary;
  const itemPropsByTouchSupport = isMobile.hasTouchSupport() ? {
    onKeyDown
  } : {
    onClick: onClickHandler,
    onKeyDown: handleOnKeyDown
  };
  return /*#__PURE__*/React__default["default"].createElement("li", _extends__default["default"]({
    className: itemClassName,
    ref: itemSelectionRef
  }, otherOptionProps, itemPropsByTouchSupport), getCheckbox(), /*#__PURE__*/React__default["default"].createElement(list.ListItemContent, _extends__default["default"]({}, itemProps, {
    title: computedTitle,
    description: computedDescription,
    rightContent: computedRightContent
  })));
};
var ListBoxItem$1 = ListBoxItem;
const _excluded$1 = ["group", "state", "listId"];
const ListBoxGroup = _ref => {
  let {
      group,
      state,
      listId
    } = _ref,
    otherProps = _objectWithoutProperties__default["default"](_ref, _excluded$1);
  const {
    rendered: heading,
    'aria-label': ariaLabel,
    props: listGroupProps,
    index
  } = group;
  const {
    itemProps,
    headingProps,
    groupProps
  } = listbox.useListBoxSection({
    heading,
    'aria-label': ariaLabel
  });
  headingProps.id = "".concat(listId, "__group-heading-").concat(index);
  groupProps['aria-labelledby'] = headingProps.id;
  return /*#__PURE__*/React__default["default"].createElement(list.ListGroup, _extends__default["default"]({
    label: "",
    itemProps: itemProps,
    headingProps: headingProps,
    groupProps: groupProps
  }, listGroupProps), [...group.childNodes].map(groupNode => /*#__PURE__*/React__default["default"].createElement(ListBoxItem$1, _extends__default["default"]({
    key: groupNode.key,
    item: groupNode,
    state: state
  }, otherProps))));
};
var ListBoxGroup$1 = ListBoxGroup;
const findItemInChildren = (children, itemKey) => {
  let findItem;
  children.forEach(child => {
    var _child$props, _child$props2;
    if (isSupportedType$1(child, ['ListOption', 'FloatingMenuItem']) && ((child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.value) === itemKey || (child === null || child === void 0 ? void 0 : child.key) === itemKey)) {
      findItem = child;
      return;
    }
    if (isSupportedType$1(child, ['ListGroup']) && child !== null && child !== void 0 && (_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.children) {
      const foundItem = findItemInChildren(child.props.children, itemKey);
      if (foundItem) {
        findItem = foundItem;
      }
    }
  });
  return findItem || null;
};
const createMouseEventForElement = element => {
  const target = element ? Object.assign(element, {
    value: undefined
  }) : {};
  const clickEvent = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  Object.defineProperty(clickEvent, 'target', {
    get: () => target
  });
  return clickEvent;
};
const _excluded = ["children", "id", "selectionComponent", "selectionMode", "isRadioList", "defaultSelectedKeys", "selectedKeys", "onClick", "onSelect", "shouldUseVirtualFocus", "srLabel"];
const ListBox = /*#__PURE__*/function () {
  const ListBox = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
        children,
        id,
        selectionComponent,
        selectionMode = 'single',
        isRadioList = false,
        defaultSelectedKeys,
        selectedKeys,
        onClick,
        onSelect,
        shouldUseVirtualFocus,
        srLabel
      } = props,
      other = _objectWithoutProperties__default["default"](props, _excluded);
    const listSelectionRef = React.useRef(null);
    const selectedManager = React.useRef({});
    const prevState = React.useRef([]);
    const callOnSelectCallback = () => {
      const {
        event,
        values,
        itemDetails
      } = selectedManager.current;
      if (event && values && itemDetails) {
        if (typeof onSelect === 'function') onSelect(event, values, itemDetails);
        selectedManager.current = {};
      }
    };
    const onItemSelect = (event, itemDetails) => {
      selectedManager.current.event = event;
      selectedManager.current.itemDetails = itemDetails;
      callOnSelectCallback();
    };
    const getIdsAndDisabledKeys = () => {
      const disabledKeys = [];
      const listItemsIds = [];
      React.Children.forEach(children, child => {
        if (isSupportedGroupType$1(child)) {
          React.Children.forEach(child.props.children, item => {
            var _item$props, _item$props2;
            listItemsIds.push("".concat(id, "-option-").concat(item.props.value));
            if ((_item$props = item.props) !== null && _item$props !== void 0 && _item$props.disabled || (_item$props2 = item.props) !== null && _item$props2 !== void 0 && _item$props2.disableSelectionComponent) disabledKeys.push(item.props.value);
          });
        }
        if (isSupportedItemType$1(child)) {
          var _child$props, _child$props2;
          if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.disabled || (_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.disableSelectionComponent) disabledKeys.push(child.props.value);
        }
      });
      return {
        disabledKeys,
        listItemsIds: listItemsIds.join(' ')
      };
    };
    const {
      disabledKeys,
      listItemsIds
    } = React.useMemo(() => getIdsAndDisabledKeys(), [children]);
    const adaptedChildren = useChildrenAdapter$1(children);
    const handleSelectionChangeForTouchDevices = values => {
      var _ref, _ref$querySelector, _itemObject$props, _itemObject$props2;
      const prevKeys = prevState.current;
      const newKeys = [...values];
      const addedKeys = newKeys.filter(key => !prevKeys.includes(key));
      const removeKeys = prevKeys.filter(key => !newKeys.includes(key));
      const itemKey = addedKeys.length > 0 ? addedKeys[0] : removeKeys[0];
      const itemElement = (_ref = ref || listSelectionRef) === null || _ref === void 0 || (_ref = _ref.current) === null || _ref === void 0 || (_ref$querySelector = _ref.querySelector) === null || _ref$querySelector === void 0 ? void 0 : _ref$querySelector.call(_ref, "li[data-key=\"".concat(itemKey, "\"]"));
      if (!itemElement) return;
      const itemObject = findItemInChildren(adaptedChildren, itemKey);
      const itemValue = itemObject === null || itemObject === void 0 || (_itemObject$props = itemObject.props) === null || _itemObject$props === void 0 ? void 0 : _itemObject$props.value;
      const clickEvent = createMouseEventForElement(itemElement);
      if (typeof onClick === 'function') {
        onClick(clickEvent, itemValue);
      }
      if (typeof onSelect === 'function') {
        onSelect(clickEvent, newKeys, {
          value: itemValue
        });
      }
      if (typeof (itemObject === null || itemObject === void 0 || (_itemObject$props2 = itemObject.props) === null || _itemObject$props2 === void 0 ? void 0 : _itemObject$props2.onSelect) === 'function') {
        itemObject.props.onSelect(clickEvent, {
          value: itemValue
        });
      }
      prevState.current = newKeys;
    };
    const onSelectionChanged = values => {
      if (isMobile.hasTouchSupport()) {
        handleSelectionChangeForTouchDevices(values);
        return;
      }
      selectedManager.current.values = Array.from(values || []);
      callOnSelectCallback();
    };
    const listStateHook = isRadioList ? list$1.useSingleSelectListState : list$1.useListState;
    const state = listStateHook(_objectSpread__default["default"](_objectSpread__default["default"]({
      disabledKeys,
      selectionMode
    }, props), {}, {
      onSelectionChange: onSelectionChanged,
      children: adaptedChildren
    }));
    const {
      listBoxProps
    } = listbox.useListBox(_objectSpread__default["default"](_objectSpread__default["default"]({
      'aria-label': srLabel,
      disallowEmptySelection: true,
      disabledKeys,
      selectionMode
    }, props), {}, {
      shouldUseVirtualFocus
    }), state, ref || listSelectionRef);
    return /*#__PURE__*/React__default["default"].createElement(list.List, _extends__default["default"]({
      "aria-owns": listItemsIds.length ? listItemsIds : undefined,
      srLabel: srLabel
    }, utils.mergeProps(other, listBoxProps), {
      ref: ref || listSelectionRef,
      "aria-label": undefined
    }), [...state.collection].map(listSelectNode => {
      const commonProps = _objectSpread__default["default"]({
        key: listSelectNode.key,
        state,
        selectionComponent
      }, isMobile.hasTouchSupport() ? {} : {
        onClick,
        onSelect: (event, itemDetails) => {
          if (typeof onItemSelect === 'function') onItemSelect(event, itemDetails);
          if (typeof listSelectNode.onSelect === 'function') listSelectNode.onSelect(event, itemDetails);
        }
      });
      return listSelectNode.type === 'item' ? /*#__PURE__*/React__default["default"].createElement(ListBoxItem$1, _extends__default["default"]({
        item: listSelectNode
      }, commonProps)) : /*#__PURE__*/React__default["default"].createElement(ListBoxGroup$1, _extends__default["default"]({
        group: listSelectNode
      }, commonProps, {
        listId: id
      }));
    }));
  });
  ListBox.displayName = 'ListBox';
  return ListBox;
}();
var ListBox$1 = ListBox;
exports.ListBox = ListBox$1;
exports["default"] = ListBox$1;
